import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { NavItem, NavSeparator } from '../../../components/layouts/Navigation/Nav';
import User from '../../../components/layouts/User/User';
import Button from '../../../components/ui/Button';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../../components/ui/Modal'; // Importing the Modal
import { appPages } from '../../../config/pages.config';
import { useApiReload } from '../../../context/apiRelaod';
import { RecordingStatus, useAudioRecording } from '../../../context/AudioRecordingContext';
import { useAuth } from '../../../context/authContext';
import { LogoutUser } from '../../../services/apiService';

const UserTemplate = () => {
	const { isLoading, userData, onLogout } = useAuth();
	// const { isRecording } = useApiReload();

	const { call } = LogoutUser();
	const navigate = useNavigate();
	const [isLogoutModalOpen, setLogoutModalOpen] = useState(false);

	// Get recording state from the updated audio recording context to perfrom logout
	const { recordings } = useAudioRecording();
	const isAnyRecordingActive = Object.values(recordings).some(
		(audio) => audio.status === RecordingStatus.RECORDING,
	);

	const verifyRecording = () => {
		if (isAnyRecordingActive) {
			const toastId = 'not-vaild';
			toast.error('Please stop the recording before logging out.', { toastId: toastId });
			return;
		} else setLogoutModalOpen(true);
	};
	const handleLogoutConfirm = () => {
		// const toastId = 409;
		call().subscribe({
			next: () => {
				// if (!toast.isActive(toastId)) {
				// 	toast.success('You have been logged out.', { toastId });
				// }
				onLogout();
				navigate('/login');
			},
			error: (e: any) => {
				toast.error(e?.data?.msg || e.message);
			},
		});

		setLogoutModalOpen(false);
	};

	return (
		<>
			<User
				isLoading={isLoading}
				name={userData?.firstName}
				position={userData?.mobile}
				src={userData?.image?.thumb}>
				<NavSeparator />
				<NavItem {...appPages.profilePage} />
				<NavItem {...appPages.patientForm} />
				<NavItem {...appPages.subscriptionPage} />
				<NavItem
					text='Logout'					
					icon='HeroArrowRightOnRectangle'
					onClick={() => verifyRecording()}
				/>
			</User>

			{/* Logout Confirmation Modal */}
			<Modal isOpen={isLogoutModalOpen} setIsOpen={setLogoutModalOpen} isCentered size='sm'>
				<ModalHeader setIsOpen={setLogoutModalOpen}>Confirm Logout</ModalHeader>
				<ModalBody className='pt-3'>
					<p className='mb-0 text-lg'>Are you sure you want to log out?</p>
				</ModalBody>
				<ModalFooter className='justify-end pt-3'>
					<Button
						variant='solid'
						color='gray'
						colorIntensity='500'
						className='cursor-pointer text-white'
						onClick={() => setLogoutModalOpen(false)}>
						Cancel
					</Button>
					<Button
						variant='solid'
						colorIntensity='600'
						className='cursor-pointer text-white primary-bg'
						onClick={handleLogoutConfirm}>
						Logout
					</Button>
				</ModalFooter>
			</Modal>
		</>
	);
};

export default UserTemplate;
